export type GenericConfig = Record<string, unknown>;
type PickStartsWith<T extends object, S extends string> = {
  [K in keyof T as K extends `${S}${infer _R}` ? K : never]: T[K];
};

export type ClientConfig<T extends GenericConfig> = PickStartsWith<
  T,
  "CLIENT_"
>;

const toClientConfig = <T extends GenericConfig>(config: T): ClientConfig<T> =>
  Object.fromEntries(
    Object.entries(config).filter(([key]) => key.startsWith("CLIENT_")),
  ) as ClientConfig<T>;

export const buildConfig = <T extends GenericConfig>(configUrl: string) => {
  const config = async (): Promise<T> => {
    const response = await fetch(configUrl);
    return (await response.json()) as Promise<T>;
  };

  const clientConfig = async () => toClientConfig(await config());

  return {
    clientConfig,
    config,
  };
};
export { buildProvider } from "./client";
